"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component is the customer uploaded artwork object on the Konva canvas
 */
var react_1 = __importDefault(require("react"));
var react_konva_1 = require("react-konva");
var react_konva_utils_1 = require("react-konva-utils");
var use_image_1 = __importDefault(require("use-image"));
function Signature(_a, ref) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var signatureProps = _a.signatureProps, _x = _a.imageUrl, imageUrl = _x === void 0 ? "" : _x, onSelect = _a.onSelect, isSelected = _a.isSelected, onChange = _a.onChange, onDelete = _a.onDelete, _y = _a.isTransformDisabled, isTransformDisabled = _y === void 0 ? false : _y;
    var image = use_image_1.default(imageUrl, "anonymous")[0];
    var shapeRef = react_1.default.useRef(null);
    // const trRef = React.useRef<any>(null);
    var _z = react_1.default.useState(false), isDeleting = _z[0], setIsDeleting = _z[1];
    react_1.default.useEffect(function () {
        var _a, _b;
        if (isSelected) {
            (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.nodes([shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current]);
            (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.getLayer().batchDraw();
        }
        else {
            setIsDeleting(false);
        }
    }, [isSelected]);
    react_1.default.useEffect(function () {
        var _a, _b, _c;
        if (((_a = signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.text) === null || _a === void 0 ? void 0 : _a.text) || signatureProps.image) {
            onSelect();
            (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.nodes([shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current]);
            (_c = ref === null || ref === void 0 ? void 0 : ref.current) === null || _c === void 0 ? void 0 : _c.getLayer().batchDraw();
        }
    }, [shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current, signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.text]);
    // console.log("ref?.current ", ref?.current);
    // console.log("shapeRef?.current ", shapeRef?.current);
    var isImage = !!imageUrl;
    var refWidth = isImage
        ? (_d = (_c = (_b = shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) === null || _b === void 0 ? void 0 : _b.attrs) === null || _c === void 0 ? void 0 : _c.width) !== null && _d !== void 0 ? _d : (_g = (_f = (_e = shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) === null || _e === void 0 ? void 0 : _e.attrs) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.naturalWidth : (_j = (_h = shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) === null || _h === void 0 ? void 0 : _h.textWidth) !== null && _j !== void 0 ? _j : 0;
    var refHeight = isImage
        ? (_m = (_l = (_k = shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) === null || _k === void 0 ? void 0 : _k.attrs) === null || _l === void 0 ? void 0 : _l.height) !== null && _m !== void 0 ? _m : (_q = (_p = (_o = shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) === null || _o === void 0 ? void 0 : _o.attrs) === null || _p === void 0 ? void 0 : _p.image) === null || _q === void 0 ? void 0 : _q.naturalHeight : (_s = (_r = shapeRef === null || shapeRef === void 0 ? void 0 : shapeRef.current) === null || _r === void 0 ? void 0 : _r.textHeight) !== null && _s !== void 0 ? _s : 0;
    // console.log("refHeight", refHeight);
    // console.log(
    //   "shapeRef?.current?.attrs?.image?.naturalWidth",
    //   shapeRef?.current?.attrs?.image?.naturalWidth
    // );
    // console.log("isTransformDisabled", isTransformDisabled);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isImage ? (react_1.default.createElement(react_konva_1.Image, { onClick: onSelect, onTap: onSelect, image: image, ref: shapeRef, draggable: !isTransformDisabled, onContextMenu: function (e) {
                e.evt.preventDefault();
                setIsDeleting(true);
            }, onDragStart: onSelect, onDragEnd: function (e) {
                onChange(__assign(__assign({}, signatureProps), { x: e.target.x(), y: e.target.y() }));
            }, width: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.width, height: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.height, x: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.x, y: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.y, scaleX: (_t = signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.scaleX) !== null && _t !== void 0 ? _t : 1, scaleY: (_u = signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.scaleY) !== null && _u !== void 0 ? _u : 1, onTransformEnd: function (e) {
                var node = shapeRef.current;
                var scaleX = node.scaleX();
                var scaleY = node.scaleY();
                node.scaleX(1);
                node.scaleY(1);
                var updatedValue = __assign(__assign({}, signatureProps), { width: Math.max(5, node.width() * scaleX), height: Math.max(node.height() * scaleY), x: node.x(), y: node.y() });
                onChange(updatedValue);
            } })) : (react_1.default.createElement(react_konva_1.Text, { on: true, onDragEnd: function (e) {
                onChange(__assign(__assign({}, signatureProps), { x: e.target.x(), y: e.target.y() }));
            }, onContextMenu: function (e) {
                e.evt.preventDefault();
                setIsDeleting(true);
            }, ref: shapeRef, draggable: !isTransformDisabled, text: (_v = signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.text) === null || _v === void 0 ? void 0 : _v.text, fill: (_w = signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.text) === null || _w === void 0 ? void 0 : _w.color, x: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.x, y: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.y, width: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.width, height: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.height, fontSize: signatureProps === null || signatureProps === void 0 ? void 0 : signatureProps.fontSize, onClick: onSelect, onTap: onSelect, onTransformEnd: function (e) {
                var node = shapeRef.current;
                var scaleX = node.scaleX();
                var scaleY = node.scaleY();
                console.log("node", node);
                node.scaleX(1);
                node.scaleY(1);
                var updatedValue = __assign(__assign({}, signatureProps), { 
                    // width: Math.max(5, node.width() * scaleX),
                    // height: Math.max(node.height() * scaleY),
                    x: node.x(), y: node.y(), scaleX: scaleX,
                    scaleY: scaleY, fontSize: node.fontSize() * scaleY });
                onChange(updatedValue);
            } })),
        isSelected && !isTransformDisabled && (react_1.default.createElement(react_konva_utils_1.Html, null,
            react_1.default.createElement("button", { style: {
                    position: "absolute",
                    top: refHeight / 2 + signatureProps.y,
                    left: refWidth + signatureProps.x + 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    outline: "none",
                    border: "1px solid #fff",
                    backgroundColor: "#fff",
                    transform: "translateY(-50%)",
                    fontSize: "12px",
                    color: "red",
                    cursor: "pointer"
                }, onClick: function () {
                    onDelete();
                    setIsDeleting(false);
                } }, "x")))));
}
exports.default = react_1.default.forwardRef(Signature);
